import { TenantDetailsApi } from '../models';
import { TenantDetailsFormDataTenant } from '../viewModels/tenantDetails/form/data/TenantDetailsFormDataTenant';
import { TenantDetailsFormDataMicrosoftPartner } from '../viewModels/tenantDetails/form/data/TenantDetailsFormDataMicrosoftPartner';

export class TenantsHelper {

  static getUpdateTenantDetails(tenantDetailsApi: TenantDetailsApi, tenant: TenantDetailsFormDataTenant, mpn: TenantDetailsFormDataMicrosoftPartner): TenantDetailsApi {
    return {
      ...tenantDetailsApi,
      name: tenant.name,
      cidn: tenant.cidn,
      isPartnerSalesChannel: tenant.isPartnerSalesChannel,
      accountManagerName: tenant.accountManagerName,
      partnerDealerCode: tenant.partnerDealerCode,
      odinAccountId: tenant.odinAccountId,
      odinPayToolId: tenant.odinPayToolId,
      awsDirectMasterAccountId: tenant.awsDirectMasterAccountId,
      cloudHealthClientApiId: tenant.cloudHealthClientApiId,
      authenticationDomain: tenant.authenticationDomain,
      cloudOrganizationId: tenant.cloudOrganizationId,
      dome9AccountId: tenant.dome9AccountId,
      azurePlanOdinSubscriptionId: tenant.azurePlanOdinSubscriptionId,
      mpnId: mpn.mpnId || '',
      mpnName: mpn.mpnName || '',
    };
  }

}
